<div class="row align-items-stretch g-3">
  <div class="col-auto">
    <div class="custom-card">
      <div id="idcard-card" class=" p-4 rounded-4 text-white">
        <h5 class="">ปลดสิทธิด้วย</h5>
        <h4 class="fw-semibold text-truncate">บัตรประจำตัวประชาชน</h4>
        <h4 class="fw-semibold text-truncate">&nbsp;</h4>
        <button class="btn btn-custom card-button" routerLink="idcard/forms" type="button">
          เลือก <i class="bi bi-chevron-right fw-bold ms-2"></i>
        </button>
      </div>
    </div>
  </div>
  <div class="col-auto">
    <div class="custom-card">
      <div id="personal-id-card" class=" p-4  rounded-4 text-white">
        <h5 class="">ปลดสิทธิด้วย</h5>
        <h4 class="fw-semibold text-truncate">เลขประจำตัวประชาชน</h4>
        <h4 class="fw-semibold text-truncate">&nbsp;</h4>
        <button class="btn btn-custom card-button" routerLink="personal-id/forms" type="button">
          เลือก <i class="bi bi-chevron-right fw-bold ms-2"></i>
        </button>
      </div>
    </div>
  </div>
</div>
